exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".class_table[data-v-aeb077bc]{width:100%;border-collapse:collapse;text-align:center;margin-top:.267rem}.class_table td[data-v-aeb077bc],.class_table th[data-v-aeb077bc]{padding:.053rem}.van-popup .van-checkbox[data-v-aeb077bc]{margin:.267rem}.van-popup .van-button[data-v-aeb077bc]{font-size:.533rem}", ""]);

// exports
